import {InvalidateOptions, InvalidateQueryFilters, QueryClient} from "react-query";

type PrefetchParams = {
    page?: number
    [others: string]: any
}

export const queryClient = new QueryClient({
    defaultOptions: {}
})

export function prefetchPage(key: string, page: number, query: Function) {
    if(page > 0){
        queryClient.prefetchQuery([key, {page}], () => query(page)).catch()
    }
}

export function prefetchNearbyPages(key: string, currentPage: number, query: Function) {
    prefetchPage(key, currentPage - 1, query)
    prefetchPage(key, currentPage + 1, query)
}

export function prefetch(key: string, parameters: PrefetchParams, query: Function) {
    const currentParameters = {...parameters, page: parameters.page || 1}

    // Prefetch previous page (if possible)
    if(currentParameters.page > 1){
        queryClient.prefetchQuery(
            [key, {...currentParameters, page: currentParameters.page - 1}],
            () => query(parameters)
        ).catch()
    }

    // Prefetch next page
    queryClient.prefetchQuery(
        [key, {...currentParameters, page: currentParameters.page + 1}],
        () => query(parameters)
    ).catch()
}

export function invalidate(key: string | Array<any>, filters?: InvalidateQueryFilters | undefined) {
    return queryClient.invalidateQueries(key, filters);
}